var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8OnlineSupport50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA726",
    d: "M10 22A4 4 0 1 0 10 30 4 4 0 1 0 10 22zM38 22A4 4 0 1 0 38 30 4 4 0 1 0 38 22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5722",
    d: "M24,3C14.6,3,7,10.6,7,20c0,1.2,0,3.4,0,3.4L9,25v-3l21-9.8l9,9.8v3l2-1.6c0,0,0-2.1,0-3.4C41,12,35.3,3,24,3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M31 24A2 2 0 1 0 31 28 2 2 0 1 0 31 24zM17 24A2 2 0 1 0 17 28 2 2 0 1 0 17 24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M43,24c-0.6,0-1,0.4-1,1v-7c0-8.8-7.2-16-16-16h-7c-0.6,0-1,0.4-1,1s0.4,1,1,1h7c7.7,0,14,6.3,14,14v10c0,0.6,0.4,1,1,1s1-0.4,1-1v2c0,3.9-3.1,7-7,7H24c-0.6,0-1,0.4-1,1s0.4,1,1,1h11c5,0,9-4,9-9v-5C44,24.4,43.6,24,43,24z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M43 22h-1c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2v-4C45 22.9 44.1 22 43 22zM24 36A2 2 0 1 0 24 40 2 2 0 1 0 24 36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8OnlineSupport50);
export default __webpack_public_path__ + "static/media/icons8-online-support-50.bbdb91b9a7ab46d515b0fa8aa39021cf.svg";
export { ForwardRef as ReactComponent };